import React from "react";
import Spinner from "./ui/Spinner";

interface LoadingSpinnerProps {
  message?: string;
  size?: "small" | "medium" | "large";
  fullHeight?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Chargement...",
  size = "medium",
  fullHeight = true,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center p-6 ${
        fullHeight ? "min-h-[200px]" : ""
      } ${className}`}
    >
      <Spinner size={size} color="primary" />
      {message && (
        <p className="mt-4 text-sm text-gray-600 text-center">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
